module.exports = __webpack_public_path__ + "static/media/cherie-fm.bce5f245.png";